import React from 'react'

export default function Arrow() {
  return (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1030_12)">
        <path
          d="M22.7882 17.5437L19.6878 23.5393L16.0485 17.8512L18.2605 17.7524C17.4418 13.6511 15.3185 9.9245 12.2077 7.12918C9.0968 4.33386 5.16523 2.61971 1 2.2427L1.20908 0C5.91709 0.425476 10.3562 2.38114 13.8477 5.56797C17.3392 8.7548 19.6909 12.9974 20.5433 17.6471L22.7882 17.5437Z"
          fill="#697D93"
        />
      </g>
      <defs>
        <clipPath id="clip0_1030_12">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
